import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=224ff245"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=224ff245&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports